export default  {"src":"/_next/static/image/public/images/icon_sm_money_dark.02c9ca669ebaba4cf11a741b95c219c8.svg","height":20,"width":26};